export default {"src":"/_next/static/media/aurigami.66d036d1.svg","height":1500,"width":1473,"blurWidth":0,"blurHeight":0};